import {
  LIST_FEATURE_FLAGS,
  useFeatureFlagWithState,
} from '@diamond/shared/utils';
import { useAuthStore, usePwaStore } from '@diamond/sol-buyer-context';
import dynamic from 'next/dynamic';

import { OfflineBanner } from './OfflineBanner';
import { usePwaHeadMetadata } from './usePwaHeadMetadata';
import { usePwaNetworkStatus } from './usePwaNetworkStatus';
import { usePwaServiceWorker } from './usePwaServiceWorker';

const PwaInstallBanner = dynamic(
  () => import('./PwaInstallBanner').then((module) => module.PwaInstallBanner),
  { ssr: false }
);

export function PwaRuntime() {
  const accessToken = useAuthStore((state) => state.access_token);
  const isPwaOffline = usePwaStore((state) => state.isPwaOffline);
  const { value: isPwaEnabled, loading: isFeatureFlagLoading } =
    useFeatureFlagWithState(LIST_FEATURE_FLAGS.FF_SOL_BUYER_PWA, false);
  const shouldRunPwa = isPwaEnabled && Boolean(accessToken);

  usePwaHeadMetadata(isPwaEnabled, isFeatureFlagLoading);
  usePwaNetworkStatus(shouldRunPwa);
  usePwaServiceWorker(shouldRunPwa, isFeatureFlagLoading);

  if (isFeatureFlagLoading || !isPwaEnabled) return null;

  return (
    <>
      {shouldRunPwa && isPwaOffline ? <OfflineBanner /> : null}
      {!isPwaOffline ? <PwaInstallBanner isPwaEnabled /> : null}
    </>
  );
}
